export default "__VITE_ASSET__qV3VkCt1__"